import api from '@pray/shared/utils/api';

export async function batchSchedulePrayTvContent({ artistId, contentId, slots }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!slots?.length) throw Error('At least one slot is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/pray-tv-schedule/batch`;
  const response = await api.executePostRequest(url, {
    slots: slots.map(({ publishedAt, sunsetAt }) => ({
      published_at: publishedAt,
      sunset_at: sunsetAt,
    })),
  });

  return response.data;
}
